import EventCollection from './EventCollection';
export default EventCollection;